<main class="login-container">
  <div class="background-gif"></div>

  <div class="left-panel">
    <div class="logo-wrapper">
      <img
        src="assets/images/Logo/login-logo.svg"
        alt="CSQ Logo"
        class="logo"
      />
    </div>
  </div>

  <div class="right-panel" [class.add-student]="addStudent">
    <!-- ── Event Info View ── -->
    <div class="right-section" *ngIf="!addStudent && !studentAdded">
      <div class="head-tittle">{{ eventData?.eventName }}</div>

      <div class="card-details">
        <div class="image-container">
          <img [src]="eventImage" alt="Event image" />
        </div>

        <div class="d-flex flex-column justify-content-around">
          <div class="details-container">
            <img
              class="field-icon"
              src="../../../assets/images/frame-1.svg"
              alt=""
            />
            <div>
              <div class="primary-label">Event type :</div>
              <div class="secondary-label">{{ eventData?.eventTypeName }}</div>
            </div>
          </div>

          <div class="d-flex align-items-center gap-5">
            <div class="details-container">
              <img
                class="field-icon"
                src="../../../assets/images/frame-2.svg"
                alt=""
              />
              <div>
                <div class="primary-label">Start date :</div>
                <div class="secondary-label">
                  {{ eventData?.eventStartDate | date: "dd-MM-yyyy" }}
                </div>
              </div>
            </div>

            <div class="details-container">
              <img
                class="field-icon"
                src="../../../assets/images/frame-2.svg"
                alt=""
              />
              <div>
                <div class="primary-label">End date :</div>
                <div class="secondary-label">
                  {{ eventData?.eventEndDate | date: "dd-MM-yyyy" }}
                </div>
              </div>
            </div>
          </div>

          <div class="details-container">
            <img
              class="field-icon"
              src="../../../assets/images/frame-4.svg"
              alt=""
            />
            <div>
              <div class="primary-label">Time :</div>
              <div class="secondary-label">{{ eventData?.eventTime }}</div>
            </div>
          </div>

          <div class="details-container">
            <img
              class="field-icon"
              src="../../../assets/images/frame-3.svg"
              alt=""
            />
            <div>
              <div class="primary-label">Location :</div>
              <div class="secondary-label">{{ eventData?.location }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-text">Would you like to register for this event?</div>

      <div class="button-container">
        <button
          class="btn act-btn"
          (click)="goToLogin()"
          [disabled]="isLoading"
        >
          <span class="btn-inline" *ngIf="!isLoading">
            <span class="btn-bold">Already have an account?</span>&nbsp;<span class="btn-light">Log in</span>
          </span>
          <span *ngIf="isLoading" class="loader-container">
            <span class="loader-text">Redirecting to login</span>
            <div class="spinner"></div>
          </span>
        </button>

        <button
          class="btn new-btn"
          (click)="addStudentFunction()"
        >
          <span class="btn-inline">
            <span class="btn-bold">New user?</span>&nbsp;<span class="btn-light">Register</span>
          </span>
        </button>
      </div>
    </div>

    <!-- ── Duplicate Email Card ── -->
    <div class="duplicate-account-card" *ngIf="addStudent && !studentAdded && duplicateEmailError">
      <div class="duplicate-account-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24"
          fill="none" stroke="#e07b39" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <div class="duplicate-account-title">You already have an account</div>
      <div class="duplicate-account-subtitle">Please log in or reset your password.</div>
      <div class="duplicate-account-actions">
        <button class="dup-login-btn" (click)="goToLogin()">Log in</button>
        <button class="dup-reset-btn" (click)="goToResetPassword()">Reset Password</button>
      </div>
    </div>

    <!-- ── Add Student Form View ── -->
    <div class="student-section" *ngIf="addStudent && !studentAdded && !duplicateEmailError">
      <div class="student-title">Add student details</div>

      <div class="grid-section">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="First name"
            placeholder="Enter your first name"
            type="text"
            [control]="form.get('firstName')"
            [customErrorMessages]="customErrorMessages.firstName"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Last name"
            placeholder="Enter your last name"
            type="text"
            [control]="form.get('lastName')"
            [customErrorMessages]="customErrorMessages.lastName"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Email (School)"
            placeholder="Enter your email"
            type="text"
            [control]="form.get('schoolEmail')"
            [customErrorMessages]="customErrorMessages.schoolEmail"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Email (Personal)"
            [optional]="true"
            placeholder="Enter your email"
            type="email"
            [control]="form.get('personalEmail')"
            [customErrorMessages]="customErrorMessages.personalEmail"
            bgColor="#292929"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Date of birth"
            placeholder="Enter your date of birth"
            type="date"
            [control]="form.get('dob')"
            [customErrorMessages]="customErrorMessages.dob"
            bgColor="#292929"
            [required]="true"
            [dateType]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Year level / Grade"
            [optional]="true"
            placeholder="Enter your year level"
            type="select"
            [options]="yearLevelOption"
            [control]="form.get('yearLevel')"
            [customErrorMessages]="customErrorMessages.yearLevel"
            bgColor="#292929"
            [required]="false"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Parent / Guardian full name"
            placeholder="Enter your parent / guardian full name"
            type="text"
            [control]="form.get('parentName')"
            [customErrorMessages]="customErrorMessages.parentName"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Parent / Guardian email"
            placeholder="Enter your parent / guardian email"
            type="text"
            [control]="form.get('parentEmail')"
            [customErrorMessages]="customErrorMessages.parentEmail"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Gender"
            placeholder="Select Gender"
            [optional]="true"
            type="select"
            [control]="form.get('gender')"
            [options]="genderOption"
            [customErrorMessages]="customErrorMessages.gender"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Ethnicity"
            placeholder="Enter your ethnicity"
            type="select"
            [options]="ethnicitiesOption"
            [control]="form.get('ethnicity')"
            [optional]="true"
            [customErrorMessages]="customErrorMessages.ethnicity"
            bgColor="#292929"
            [required]="true"
          ></app-input>
        </div>
      </div>

      <div class="course-text">Course Background</div>

      <div class="question-grid">
        <div class="primary-text">
          1. Have you (the student) enrolled in a construction-related course at
          any level within the past 12 months ?
        </div>
        <div class="course-select-wrap">
          <app-input
            context="Normal"
            class="form-item"
            placeholder="Select"
            [optional]="true"
            type="select"
            [control]="form.get('constructionCourse')"
            [options]="dataOption"
            bgColor="#292929"
            [customErrorMessages]="customErrorMessages.constructionCourse"
          ></app-input>
        </div>
      </div>

      <div class="checkbox-grid" *ngIf="showConstructionCourseAnswers">
        <div
          *ngFor="let area of constructionPastAnswers"
          class="checkbox-wrapper"
        >
          <label class="custom-checkbox">
            <input
              type="checkbox"
              [value]="area.value"
              (change)="onFocusAreaChange($event, 1)"
              [checked]="form.value.focusArea?.includes(area.value)"
            />
            <span class="checkmark"></span>
            <span class="form-label2">{{ area.label }}</span>
          </label>
        </div>
        <div class="error-message-container" *ngIf="showPastAnswersError">
          <div class="error-message">Please select at least one course.</div>
        </div>
      </div>

      <div class="question-grid">
        <div class="primary-text">
          2. Are you currently or have completed any
          construction related courses ?
        </div>
        <div class="course-select-wrap">
          <app-input
            context="Normal"
            class="form-item"
            placeholder="Select"
            [optional]="true"
            type="select"
            [control]="form.get('constructionRelatedCourse')"
            [options]="dataOption"
            bgColor="#292929"
            [customErrorMessages]="
              customErrorMessages.constructionRelatedCourse
            "
          ></app-input>
        </div>
      </div>

      <div class="checkbox-grid" *ngIf="showConstructionRelatedCourseAnswers">
        <div
          *ngFor="let area of constructionCompAnswers"
          class="checkbox-wrapper"
        >
          <label class="custom-checkbox">
            <input
              type="checkbox"
              [value]="area.value"
              (change)="onFocusAreaChange($event, 2)"
              [checked]="form.value.focusArea2?.includes(area.value)"
            />
            <span class="checkmark"></span>
            <span class="form-label2">{{ area.label }}</span>
          </label>
        </div>
        <div class="error-message-container" *ngIf="showCompAnswersError">
          <div class="error-message">Please select at least one course.</div>
        </div>
      </div>

      <div
        class="d-flex justify-content-center align-items-center gap-4 mt-5 mobile-view"
      >
        <button class="cancel-btn" (click)="onCancel()">Cancel</button>
        <button class="save-btn" (click)="onSave()" [disabled]="isLoading || !!duplicateEmailError">
          <mat-spinner *ngIf="isLoading" diameter="20" strokeWidth="2"></mat-spinner>
          {{ isLoading ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>

    <!-- ── Success View ── -->
    <div
      *ngIf="studentAdded"
      class="d-flex align-items-center justify-content-center w-100"
    >
      <div class="thum-container">
        <img
          class="thumb"
          src="../../../assets/animations/thumb.gif"
          alt="Success"
        />
        <div class="head-tittle">Success</div>
        <div class="success-text">
          Your interest in this upcoming event has been saved!
        </div>
        <div class="success-text-second">
          Next, your parent or guardian will receive an email to approve your account.
        </div>
        <div class="success-text-second">
          Once approved, we'll send you your login details so you can get started — keep an eye on your inbox!
        </div>
        <div class="success-text-second">Thank you for registering.</div>
        <button  (click)="goBackEvent()" class="save-btn" >
          Okay, Close
        </button>
      </div>
    </div>
  </div>
</main>
